import { HowdenApiEnviroment, IHowdenApiInfo, IHowdenApiPaths } from '@howdeniberia/core-front';
import { CLIENTS_SEARCH_CONSTANTS } from '../../constants/clients-search.constants';

export const ClientsSearchApiInfo: IHowdenApiInfo[] = [
  {
    name: CLIENTS_SEARCH_CONSTANTS.ClientIDAName,
    paths: {
      local: 'https://how-ib-idaclients-dev.azurewebsites.net',
      development: 'https://how-ib-idaclients-dev.azurewebsites.net',
      staging: 'https://how-idaclients.app-staging.howdeniberia.com/',
      production: 'https://how-idaclients.app.howdeniberia.com'
    } as IHowdenApiPaths,
    needsToken: true,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE
  },
  {
    name: CLIENTS_SEARCH_CONSTANTS.CompanyIDAName,
    paths: {
      local: 'https://how-ib-idacompany-dev.azurewebsites.net',
      development: 'https://how-ib-idacompany-dev.azurewebsites.net',
      staging: 'https://how-idacompany.app-staging.howdeniberia.com',
      production: 'https://how-idacompany.app.howdeniberia.com'
    } as IHowdenApiPaths,
    needsToken: true,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE
  },
  {
    name: CLIENTS_SEARCH_CONSTANTS.MastersIDAName,
    paths: {
      local: 'https://how-ib-idamaster-dev.azurewebsites.net',
      development: 'https://how-ib-idamaster-dev.azurewebsites.net',
      staging: 'https://how-idamaster.app-staging.howdeniberia.com/',
      production: 'https://how-idamaster.app.howdeniberia.com'
    } as IHowdenApiPaths,
    needsToken: true,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE
  }
] as IHowdenApiInfo[];
